<template>
  <div>
  </div>
</template>

<script>
import { uuid } from 'vue-uuid';
import { mapState } from "vuex";

export default {
  name: 'BbmsCreditCardForm',
  data() {
    return {
      serverError: undefined,
      Blackbaud_OpenPaymentForm: Blackbaud_OpenPaymentForm,
    };
  },
  mounted() {
    this.loadBbmsPopup();
  },
  beforeDestroy() {
    this.detachBbmsEvents();
  },
  computed: {
    hasErrors() {
      return this.serverError;
    },
    ...mapState({
      payload: (state) => state.donationModal.payload,
    }),
  },
  methods: {
    loadBbmsPopup() {
      // Create transaction data
      const transactionData = {
        key: process.env.VUE_APP_BBMS_KEY,
        payment_configuration_id: process.env.VUE_APP_BBMS_PAYMENT_CONFIGURATION_ID,
        transaction_type: "card_not_present",
        card_token: this.payload.donation.type === "Regular" ? uuid.v4() : undefined,
        amount: this.payload.donation.amount,
        billing_address_email: this.payload.supporter.email,
        billing_address_country: this.payload.billingAddress.country || 'Australia',
        billing_address_state: this.payload.billingAddress.state,
        billing_address_city: this.payload.billingAddress.suburb,
        billing_address_line: this.getAddressLine(),
        billing_address_post_code: this.payload.billingAddress.postalCode,
        billing_address_phone: this.payload.supporter.phoneNumber,
        note: `${this.payload.donation.campaignId}|${this.payload.donation.fundId}|${this.payload.donation.appealId}|${this.payload.donationProductDetails.id}|${this.payload.donationProductDetails.productname}|${this.payload.donation.type}`,
        description: `${this.payload.donation.type === "Regular" ? "Monthly" : "One-off"} Donation`,
        is_email_required: true,
        secondary_color: '#ff003b',
      };

      this.Blackbaud_OpenPaymentForm(transactionData);

      this.attachBbmsEvents();
    },
    getAddressLine() {
      let addressLine = "";
      if (this.payload.billingAddress.unitNumber) {
        addressLine += this.payload.billingAddress.unitNumber + " ";
      }

      if (this.payload.billingAddress.streetNumber) {
        addressLine += this.payload.billingAddress.streetNumber + " ";
      }

      if (this.payload.billingAddress.streetName) {
        addressLine += this.payload.billingAddress.streetName;
      }

      return addressLine;
    },
    checkoutReady() {
      console.log("checkout is ready");
    },
    checkoutLoaded() {
      console.log("checkout is loaded");
    },
    checkoutCancel() {
      console.log("checkout was cancelled");
      this.serverError = null;
      this.$emit("close");
    },
    checkoutComplete(e) {
      console.log("transaction token: ", e.detail.transactionToken);

      // We remove the transaction token from the event data to avoid logging it
      const token = e.detail.transactionToken;
      delete e.detail.transactionToken;

      this.$emit("success", {
        token,
      });
    },
    checkoutError(e) {
      console.log("error text: ", e.detail.errorText);
      console.log("error code: ", e.detail.errorCode);

      // Restart the process
      this.$emit("close");
    },
    attachBbmsEvents() {
      document.addEventListener("checkoutReady", this.checkoutReady);
      document.addEventListener("checkoutLoaded", this.checkoutLoaded);
      document.addEventListener("checkoutCancel", this.checkoutCancel);
      document.addEventListener("checkoutComplete", this.checkoutComplete);
      document.addEventListener("checkoutError", this.checkoutError);
    },
    detachBbmsEvents() {
      document.removeEventListener("checkoutReady", this.checkoutReady);
      document.removeEventListener("checkoutLoaded", this.checkoutLoaded);
      document.removeEventListener("checkoutCancel", this.checkoutCancel);
      document.removeEventListener("checkoutComplete", this.checkoutComplete);
      document.removeEventListener("checkoutError", this.checkoutError);
    },
  },
}
</script>

<style>

</style>